module MySubscriptions
{
    ﻿var subscriptionListItem = `
                <tr>
                    <td class="hidden-xs">ModelActive</td>
                    <td class="hidden-xs hidden-sm">ModelRenewal</td>
                    <td>ModelHasSubscription</td>
                    <td>ModelIMEI</td>
                    <td align="center">
                        <a class="StartSub btn btn-sm btn-primary">` + localizer["MySubscriptionsStart"] + ` &nbsp;<em class="fa fa-plus"></em></a>
                        <a class="StopSub btn btn-sm btn-primary">` + localizer["MySubscriptionsStop"] + ` <em class="fa fa-remove"></em></a>
                    </td>
                </tr>`;
    
    RequireLogin(() => InitializeSubscriptionsView());

    export function InitializeSubscriptionsView() {
        webUser.devices.forEach(device => {
            var deviceHTML = subscriptionListItem.replace("ModelActive", device.isActive ? localizer["ResponseYes"] : localizer["ResponseNo"])
                .replace("ModelRenewal", device.hasSubscription ? DateToDateString(device.subscription.renewalDate) : localizer["NotAvailable"])
                .replace("ModelHasSubscription", device.hasSubscription ? localizer["ResponseYes"] : localizer["ResponseNo"])
                .replace("ModelIMEI", device.imei.toString()).replace("ModelIMEI", device.imei.toString());

            var element = document.createElement("tr");
            element.innerHTML = deviceHTML;

            if (!device.hasSubscription)
            {
                var hasCard = webUser.subscriptionType == CustomerAPI.PaymentType.Stripe && webUser.paymentCardNumber != null && webUser.paymentCardNumber.length > 0;
                element.getElementsByClassName("StartSub")[0].addEventListener("click", () => MySubscriptions.StartSubscriptionOnIMEI(device.imei, device.name));
                element.getElementsByClassName("StopSub")[0].remove();
            }
            else
            {
                element.getElementsByClassName("StartSub")[0].remove();
                element.getElementsByClassName("StopSub")[0].addEventListener("click", () => MySubscriptions.StopSubscriptionOnIMEI(device.imei));
            }

            document.getElementById('subscriptionsList').appendChild(element);
        });
    }

    export function StopSubscriptionOnIMEI(imei: number) {
		CustomerAPI.subscriptionsAPI.stopSubscription(imei, () => location.reload(), (ex, reason) => Alert.OpenError(localizer["ErrorHeaderStopSubscription"], ex));
    }

    export function StartSubscriptionOnIMEI(imei: number, deviceName: string) {
        var hasCard = webUser.subscriptionType == CustomerAPI.PaymentType.Stripe && webUser.paymentCardNumber != null && webUser.paymentCardNumber.length > 0;
        if (!hasCard)
        {
            Alert.OpenError(localizer["MySubscriptionsErrorNoCardTitle"], localizer["MySubscriptionsErrorNoCardMessage"])
            return;
        }

        if (deviceName == undefined || deviceName == null || deviceName == "" || deviceName == " ")
            deviceName = imei.toString();
        deviceName = '"' + deviceName + '"';

        Alert.OpenConfirm(localizer["MySubscriptionsCreateTitle"], localizer["MySubscriptionsCreateMessage"].replace("{{deviceName}}", deviceName), confirm =>
        {
            if (confirm)
                CustomerAPI.subscriptionsAPI.stripeStartRecurring(imei, result => AddedSubscriptionMessage(result), (ex, reason) => Alert.OpenError(localizer["ErrorHeaderAddSubscription"], ex));
        });
    }

    export function AddedSubscriptionMessage(result: CustomerAPI.WebStartRecurringResult) {
        var normalMessage = localizer["MySubscriptionsStartedNormalMessage"];
        var deletedMessage = localizer["MySubscriptionsStartedDeletedMessage"]
        Alert.OpenSuccess(localizer["MySubscriptionsStartedTitle"], result.isDeviceDeleted ? deletedMessage : normalMessage, () => { location.reload() });
    }
}